export default "__VITE_ASSET__f3145ac5__"